export class Loan {
  mambuId: string;
  IsLoanDisbursed: boolean;
  NextDueAmount: number;
  NumberOfPaidRepayments: number;
  NumberOfRemainingRepayments: number;
  PrincipalPaid: number;
  TotalDueAmount: number;
  TotalExpectedAmountAsOfToday: number;
  TotalPaidAmount: number;
  application: any;
  ExternalId: string;
  LoanExternalId: string;
  MerchantOrderId: string;
  MerchantName: string;
  BasketSize: number;
  Status: string;
  logoUrl: string;
  ProductNames: string[];
  LoanAmount: number;
  EmiAmount: number;
  OrderId: string;
  NumbersOfMonth: number;
  AmountPaid: number;
  NextDueDate: string;
  Amount: number;
  TotalInstallmentAmount: number;
  Terms: number;
  CreatedOn: string;
  Repayments: Repayment[];
  TotalAmount: number;
  nachRepayment: NachRepayment;
  nachRepaymentError: boolean;
  showQuickPay = 0;
  MerchantDetails: MerchantDetails;
  FeeAndPenaltyDue: number;
  showPreclose = 0;
}

export class MerchantDetails {
  IsExtendedApiMerchant: boolean;
  IsVoucherMerchant: boolean;
  MerchantUrl: string;
}

export class Repayment {
  No: number;
  DueDate: string;
  TotalDueAmount: number;
  TotalPaidAmount: number;
  PrincipalDue: number;
  PrincipalPaid: number;
  InterestDue: number;
  InterestPaid: number;
  FeesDue: number;
  FeesPaid: number;
  PenaltyDue: number;
  PenaltyPaid: number;
  TotalDue: number;
  TotalPaid: number;
  Balance: number;
  State: string;
}

export class NachRepayment {
  FailureReason: number;
  LoanId: string;
  Amount: number;
  StartedOn: string;
  CompletedOn: string;
  IsSuccess: boolean;
}


export class NachStatus {
  customerId: string;
  applicationId: string;
  nachRegistrationId: string;
  registrationStatus: string;
  accountHolderName: string;
  createdOn: string;
}


export class EmiDue {
  amount: number;
  date: string;
  index: number;
  constructor() {
    this.amount = 0;
    this.date = null;
    this.index = null;
  }
}

export class Application {
  ApplicationId: string;
  ApprovedUrl: string;
  BasketAmount: number;
  BasketItems: BasketItems[];
  CreatedOn: string;
  CustomerId: string;
  CustomerRank: null;
  DownpaymentAmount: number;
  DownpaymentRate: string;
  InitialPaymentAmount: number;
  InterestAmount: number;
  InterestFreeMonths: number;
  InterestRate: number;
  IsCODEnabled: boolean;
  IsDPMade: boolean;
  IsDownpaymentProvidedByMerchant: boolean;
  IsRiskApproved: boolean;
  IsRiskDeclined: boolean;
  LoanAmount: number;
  MerchantId: string;
  MerchantName: string;
  GenericMerchantName: string;
  MerchantOrderId: string;
  NumberOfInstallments: number;
  ProcessingFee: number;
  ProcessingFeeRate: number;
  ReturnUrl: string;
  Status: number;
  TotalInstallmentAmount: number;
  PaymentMode: string;
  ShowKycUnderLimitByDefault: boolean;
  IsExtendedApiMerchant: boolean;
  IsVoucherMerchant: boolean;
  MerchantUrl: string;
}

export class BasketItems {
  Category: string;
  Description: string;
  MerchantItemId: string;
  Quantity: number;
  TotalPrice: number;
}

export class GiftCardDetails {
  voucherCode: string;
  voucherPin: string;
  voucherValue: number;
  voucherValidity: number;
  merchantName: string;
  errorSegment: GiftCardDetailsErrorSegment;
}

export class GiftCardVouchers {
  giftCardDetails: GiftCardDetails[];
  giftCardGenerationStatus: GiftCardGenerationStatus;
}

export enum GiftCardGenerationStatus {
  SUCCESS = <any>'SUCCESS',
  FAILURE = <any>'FAILURE',
  PARTIAL_FAILURE = <any>'PARTIAL_FAILURE',
  PENDING = <any>'PENDING'
}

export class GiftCardDetailsErrorSegment {
  result: GiftCardGenerationStatus;
  ErrorMessage: string;
}

export class MambuLoan {
  LoanApplicationId: string;
  MambuLoanEncodedKey: string;
  MambuLoanId: string;
}
export class RazorpayPaymentStatus {
  LoanApplicationId: string;
  RazorpayPaymentId: string;
  Amount: number;
  StartedOn: string;
  ProcessedOn: string;
  PaymentStatus: number;
  MambuLoanId: string;
}
